import { EvaneosToolsContext } from '@b2b-ui/theme/providers/EvaneosToolsProvider';
import React from 'react';

/**
 * Utility hook to convert pixels to rem using the current theme's root font size.
 */
export const usePxToRem = () => React.useContext(EvaneosToolsContext).pxToRem;
